import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const FinalCTA = ({ scrollToContact }) => {
  return (
    <section className="py-32 px-6 bg-gradient-to-b from-[#0B0F1A] to-[#121826] relative overflow-hidden">
      {/* Glowing background effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2F6BFF]/10 rounded-full blur-3xl"></div>
      <div className="absolute top-20 left-10 w-96 h-96 bg-[#4DA3FF]/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#2F6BFF]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 mb-8 rounded-full bg-gradient-to-br from-[#2F6BFF] to-[#4DA3FF] shadow-lg shadow-[#2F6BFF]/50 animate-pulse">
          <Sparkles className="h-10 w-10 text-white" />
        </div>

        {/* Heading */}
        <h2 className="text-5xl md:text-6xl font-bold text-[#F5F7FF] mb-6 leading-tight">
          Ready to Grow Your
          <span className="block bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] bg-clip-text text-transparent">
            Business Online?
          </span>
        </h2>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-[#9AA3B2] mb-12 max-w-2xl mx-auto leading-relaxed">
          Let's build a professional website that attracts more customers and helps your business stand out.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={scrollToContact}
            size="lg"
            className="w-full sm:w-auto bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] hover:from-[#4DA3FF] hover:to-[#2F6BFF] text-white text-lg px-14 py-8 font-semibold hover:scale-105 transition-all duration-300 shadow-2xl shadow-[#2F6BFF]/50 hover:shadow-[#4DA3FF]/70"
          >
            Book a Free Consultation
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-[#9AA3B2]">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#4DA3FF]"></div>
            <span>No credit card required</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#4DA3FF]"></div>
            <span>14-day money back guarantee</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#4DA3FF]"></div>
            <span>Setup in minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
